import { dependencies } from './workflow.dependency';

/**
 * URL info on path. Will redirect for arrayLink
 * @param configPath path to examine
 */
const arrayInfo = (configPath: string): string => {
  const info = dependencies.storageInfoService.parse(configPath);
  return !info ? configPath : info.config?.arrayLink || info.storageId;
};

/**
 * Tell the length of the array based on the '$' in the stateful value ID (aka path)
 * @param configPath stateful value ID (should include the '$' or '#')
 * @param pageIterationId required when page is iterated (pathes with #)
 * @param throwOnMissingArray throws error if array is missing (defaults to returning 0)
 */
const arraySize = (configPath: string, pageIterationId?: number, throwOnMissingArray?: boolean): number => {
  const path = arrayInfo(configPath);
  const size = dependencies.storageService.arraySizes[dependencies.storageService.arrayRootPathOf(path, pageIterationId)];
  if (size == null && throwOnMissingArray) {
    throw new Error('No array for: ' + configPath);
  }
  return size || 0;
};

export const statefulArrayHelper = {
  arrayInfo,
  arraySize
};
